__turbopack_context__.v({
  "accordionChevron": "DrstKq_accordionChevron",
  "accordionChevronOpen": "DrstKq_accordionChevronOpen",
  "accordionContent": "DrstKq_accordionContent",
  "accordionControl": "DrstKq_accordionControl",
  "accordionItem": "DrstKq_accordionItem",
  "accordionItemContent": "DrstKq_accordionItemContent",
  "accordionLabel": "DrstKq_accordionLabel",
  "accordionPanel": "DrstKq_accordionPanel",
  "content": "DrstKq_content",
  "footer": "DrstKq_footer",
  "icon": "DrstKq_icon",
  "menuIcon": "DrstKq_menuIcon",
  "menuLabel": "DrstKq_menuLabel",
  "sidebar": "DrstKq_sidebar",
  "sidebarContent": "DrstKq_sidebarContent",
  "stack": "DrstKq_stack",
  "sticky": "DrstKq_sticky",
  "tabWrapper": "DrstKq_tabWrapper",
  "withFooter": "DrstKq_withFooter",
});
